import FormulaPadraoModel from "@/models/formulaPadraoModel";
import Delay from "@/utils/common/delay";
import nfetch from "@/utils/events/nfetch";

import { iServiceCached } from "./base/iServiceCached";

class FormulaPadraoDesmembradoService extends iServiceCached<FormulaPadraoModel> {
    protected formulaEstoqueCached: { [estoqueId: number]: FormulaPadraoModel[] } = {};
    protected loadingCacheEstoque = false;

    constructor() {
        super("FormulaPadrao");
    }

    public async comboMethod() {
        return await nfetch(`/${this.controllerName}/ListDesmembrado?`, {
            credentials: "same-origin",
        })
            .withLoading()
            .resolveWithJSON<Promise<FormulaPadraoModel[]>>();
    }

    public async comboCached(franquiaId: number, refresh = false) {
        const retorno = await this.combo(franquiaId, refresh);
        return retorno.map(item => ({ value: item.id, text: `${item.produtoId} - ${item.descricao}` }));
    }

    public async comboCachedByEstoque(estoqueId: number) {
        const retorno = await this.listDesmembradoByEstoqueId(estoqueId);
        return retorno.map(item => ({ value: item.id, text: `${item.produtoId} - ${item.descricao}` }));
    }

    private async listDesmembradoByEstoqueId(estoqueId: number): Promise<FormulaPadraoModel[]> {
        while (this.loadingCacheEstoque) await Delay(100);

        if (this.formulaEstoqueCached[estoqueId]) {
            return this.formulaEstoqueCached[estoqueId];
        }

        this.loadingCacheEstoque = true;

        try {
            const response = await nfetch(`/${this.controllerName}/ListDesmembradoByEstoqueId?estoqueId=${estoqueId}`, {
                credentials: "same-origin",
            }).resolveWithJSON<Promise<FormulaPadraoModel[]>>();

            this.formulaEstoqueCached[estoqueId] = response;

            return response;
        } catch {
        } finally {
            this.loadingCacheEstoque = false;
        }
    }
}

export default new FormulaPadraoDesmembradoService();
